var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 63,
    viewBox: "0 0 462 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6H327.439C333.882 6.00006 344.544 6.27568 345.012 18.4054C345.481 30.5352 333.882 30.8108 327.439 30.8108H141.745C136.18 30.8108 128.858 32.8783 128.858 44.5946C128.858 56.3108 136.18 57 141.745 57H455.5",
    stroke: "#B5B895",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#B5B895"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 57,
    r: 6,
    fill: "#B5B895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.2d66c71e8bd27268a56e491267087567.svg";
export { ForwardRef as ReactComponent };